import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Translate, withLocalize } from 'react-localize-redux';
import { reportActions } from '../../../store/reportStore';
import Money from '../../common/moneyComponent';
import OldStyleTableWithHistory from '../../common/oldStyleTableWithHistory';

import './liens.css';

class Lien extends React.Component {
    state = { expanded: false };

    toggleContent = () => {
        this.setState(state => ({ expanded: !state.expanded }));
    }

    render() {
        return (
            <>
                <tr className="colorize">
                    <td>{this.props.lien.fileMark.replace("NCRzp ", "")}</td>
                    <td>{this.props.lien.type}</td>
                    <td>
                        {this.props.lien.startDateFormated}
                    </td>
                    <td style={{ textAlign: "right" }}>
                        <span className="link-functional" onClick={() => this.toggleContent()}>
                            <Translate id={this.state.expanded === true ? "Report.Hide" : "Report.Detail"} />
                        </span>
                    </td>
                </tr>
                {this.state.expanded === true && <tr className="without-strip">
                    <td colSpan={4}>
                        {this.renderLienInfo(this.props.lien)}
                        {this.renderRelatedSubjects(this.props.lien.relatedSubjects)}
                        {this.renderDebts(this.props.lien.debts)}
                        {this.renderDeposits(this.props.lien.deposits)}
                        <br />
                    </td>
                </tr>}
            </>
        );
    }

    renderLienInfo = (lien) => {
        const data = [
            { key: "fileMark", label: "Report.Liens.FileMark", value: lien.fileMark.replace('NCRzp ', '') },
            { key: "startDate", label: "Report.Liens.DetailStartDate", value: lien.startDateFormated },
            { key: "lienType", label: "Report.Liens.DetailLienType", valeu: lien.type },
            { key: "registrator", label: "Report.Liens.Registrator", value: lien.registrar }
        ];

        return (
            <OldStyleTableWithHistory stripped noMargin tableColumns={4} classNames={{ "old-style-table-report-history": this.props.isHistorical, "key-value": true }}
                resolveExpanded={this.props.resolveExpanded}
                head={() => <thead>
                    <tr className="liens-head">
                        <th colSpan={2}><Translate id="Report.Liens.Identifiers" /></th>
                    </tr>
                </thead>}
                actualData={data}
                actualRow={(r) => <tr key={r.key}>
                    <td style={{ width: "40%", fontWeight: "bold" }}><Translate id={r.label} /></td>
                    <td>{r.value}</td>
                </tr>}
            />
        );
    }

    renderRelatedSubjects = (relatedSubjects) => {
        const subjectTypes = [
            { id: 'LI', translationKey: 'Pledgers' },
            { id: 'DE', translationKey: 'Debtors' },
            { id: 'CR', translationKey: 'Creditors' }
        ];

        return (
            <>
                {subjectTypes.map(subjectType => relatedSubjects.filter(subject => subject.typeId === subjectType.id).length > 0 && <OldStyleTableWithHistory
                    stripped tableColumns={3} classNames={{ "old-style-table-report-history": this.props.isHistorical }}
                    resolveExpanded={this.props.resolveExpanded}
                    head={() => <thead>
                        <tr className="liens-head">
                            <th colSpan={3}><Translate id={"Report.Liens." + subjectType.translationKey} /></th>
                        </tr>
                        <tr className="liens-head-2">
                            <th style={{ width: "40%" }}><Translate id="Report.Liens.SubjectName" /></th>
                            <th style={{ width: "40%" }}><Translate id="Report.Liens.SubjectAddress" /></th>
                            <th style={{ width: "20%" }}><Translate id="Report.Liens.SubjectIco" /></th>
                        </tr>
                    </thead>}
                    actualData={relatedSubjects.filter(subject => subject.typeId === subjectType.id)}
                    actualRow={(r) => <tr key={r.relationId} className="colorize">
                        <td style={{ fontWeight: "bold" }}>{r.name}</td>
                        <td>{r.address}</td>
                        <td>{r.ico}</td>
                    </tr>}
                />)}
            </>
        );
    }

    renderDebts = (debts) => {
        return (
            <OldStyleTableWithHistory stripped noMargin tableColumns={2} classNames={{ "old-style-table-report-history": this.props.isHistorical, "key-value": true }}
                resolveExpanded={this.props.resolveExpanded}
                head={() => <thead>
                    <tr>
                        <th style={{ width: "25%" }}><Translate id="Report.Liens.Debts" /></th>
                        <th style={{ width: "75%" }} />
                    </tr>
                </thead>}
                actualData={debts}
                actualRow={(debt) => <React.Fragment key={debt.id}>
                    <tr className="colorize">
                        <td style={{ fontWeight: "bold" }}><Translate id="Report.Liens.DebtPrice" /></td>
                        <td><Money value={debt.price} fractionDigits={2} /></td>
                    </tr>
                    <tr className="colorize">
                        <td style={{ fontWeight: "bold" }}><Translate id="Report.Liens.DebtMaxPrice" /></td>
                        <td><Money value={debt.maxPrice} fractionDigits={2} /></td>
                    </tr>
                    <tr className="colorize">
                        <td style={{ fontWeight: "bold" }}><Translate id="Report.Liens.DebtType" /></td>
                        <td>{debt.type}</td>
                    </tr>
                    <tr className="colorize">
                        <td style={{ fontWeight: "bold" }}><Translate id="Report.Liens.Currency" /></td>
                        <td>{debt.currency}</td>
                    </tr>
                    <tr className="colorize">
                        <td style={{ fontWeight: "bold" }}><Translate id="Report.Liens.DebtSpecification" /></td>
                        <td>{debt.specification}</td>
                    </tr>
                    <tr className="colorize">
                        <td style={{ fontWeight: "bold" }}><Translate id="Report.Liens.DebtDeadlineData" /></td>
                        <td>{debt.deadlineDateFormated}</td>
                    </tr>
                    <tr className="colorize">
                        <td style={{ fontWeight: "bold" }}><Translate id="Report.Liens.DebtDueData" /></td>
                        <td>{debt.dueDateFormated}</td>
                    </tr>
                </React.Fragment>}
            />
        );
    }

    renderDeposits = (deposits) => {
        return (
            <OldStyleTableWithHistory stripped noMargin tableColumns={4} classNames={{ "old-style-table-report-history": this.props.isHistorical, "key-value": true }}
                resolveExpanded={this.props.resolveExpanded}
                head={() => <thead>
                    <tr>
                        <th style={{ width: "25%" }}><Translate id="Report.Liens.Deposits" /></th>
                        <th style={{ width: "75%" }} />
                    </tr>
                </thead>}
                actualData={deposits}
                actualRow={(deposit) => <React.Fragment key={deposit.id}>
                    <tr className="colorize">
                        <td style={{ fontWeight: "bold" }}><Translate id="Report.Liens.DepositType" /></td>
                        <td>{deposit.type}</td>
                    </tr>
                    <tr className="colorize">
                        <td style={{ fontWeight: "bold" }}><Translate id="Report.Liens.DepositPrice" /></td>
                        <td><Money value={deposit.price} fractionDigits={2} /></td>
                    </tr>
                    <tr className="colorize">
                        <td style={{ fontWeight: "bold" }}><Translate id="Report.Liens.Currency" /></td>
                        <td>{deposit.currency}</td>
                    </tr>
                    <tr className="colorize">
                        <td style={{ fontWeight: "bold" }}><Translate id="Report.Liens.DepositDescription" /></td>
                        <td>{deposit.description}</td>
                    </tr>
                    <tr className="colorize">
                        <td style={{ fontWeight: "bold" }}><Translate id="Report.Liens.DepositModalities" /></td>
                        <td>{deposit.modalities}</td>
                    </tr>
                </React.Fragment>}
            />
        );
    }
}

export default withLocalize(connect(
    state => state.report,
    dispatch => bindActionCreators(reportActions, dispatch)
)(Lien));